(function () {

const $68cce00e20779c30$var$navContainer = document.querySelector(".js-main-navbar");
const $68cce00e20779c30$export$240cd81d1fa164a8 = ()=>{
    $68cce00e20779c30$var$setScrollbarWidth();
    const navigationPopover = document.getElementById("navigation-popover");
    const navigationPopoverTrigger = document.getElementById("navigation-popover-trigger");
    if (!navigationPopover || !navigationPopoverTrigger) return;
    let navigationPopoverActive = navigationPopoverTrigger.offsetParent !== null;
    if (navigationPopoverActive) navigationPopover.setAttribute("popover", "");
    const navItems = $68cce00e20779c30$var$navContainer.querySelectorAll("a[popovertarget]");
    navItems.forEach((item)=>{
        let closeTimeout;
        const popoverTargetId = item.getAttribute("popovertarget");
        const popoverTarget = document.querySelector(`#${popoverTargetId}`);
        if (popoverTarget) {
            item.hidePopover = ()=>{
                popoverTarget.hidePopover();
            };
            item.addEventListener("click", (e)=>{
                if (navigationPopoverActive) {
                    e.preventDefault();
                    popoverTarget.style.setProperty("--anchor-top", `64px`);
                    setTimeout(popoverTarget.togglePopover(), 1);
                }
            });
            item.addEventListener("mouseover", (e)=>{
                if (!navigationPopoverActive) {
                    clearTimeout(closeTimeout);
                    $68cce00e20779c30$var$setOffset(item, popoverTarget);
                    popoverTarget.showPopover();
                }
            });
            item.addEventListener("mouseleave", (e)=>{
                if (!navigationPopoverActive) closeTimeout = setTimeout(item.hidePopover, 1);
            });
            popoverTarget.querySelector(".c-navigation-menu__sub").addEventListener("mouseover", (e)=>{
                if (!navigationPopoverActive) clearTimeout(closeTimeout);
            });
            popoverTarget.querySelector(".c-navigation-menu__sub").addEventListener("mouseleave", (e)=>{
                if (!navigationPopoverActive) closeTimeout = setTimeout(item.hidePopover, 1);
            });
            window.addEventListener("resize", ()=>{
                $68cce00e20779c30$var$setScrollbarWidth();
                navigationPopoverActive = navigationPopoverTrigger.offsetParent !== null;
                if (navigationPopoverActive) navigationPopover.setAttribute("popover", "");
                else navigationPopover.removeAttribute("popover");
            });
        }
    });
};
const $68cce00e20779c30$var$setScrollbarWidth = ()=>{
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
};
const $68cce00e20779c30$var$setOffset = (item, popoverTarget)=>{
    const itemPosition = item.getBoundingClientRect();
    const arrowPosition = itemPosition.left + itemPosition.width / 2;
    const { y: navbarBottom } = $68cce00e20779c30$var$navContainer.getBoundingClientRect();
    const topSpacing = navbarBottom + $68cce00e20779c30$var$navContainer.offsetHeight;
    popoverTarget.style.setProperty("--arrow-position-left", `${arrowPosition}px`);
    popoverTarget.style.setProperty("--popover-hover-trigger", popoverTarget.id);
    popoverTarget.style.setProperty("--anchor-top", `${topSpacing}px`);
};


const $7e4debd3f64ec3ac$export$f808344a2ba3e03 = ()=>{
    const filterPopover = document.getElementById("filter-popover");
    const filterPopoverTrigger = document.getElementById("filter-popover-trigger");
    if (!filterPopover || !filterPopoverTrigger) return;
    let filterPopoverActive = filterPopoverTrigger.offsetParent !== null;
    if (filterPopoverActive) filterPopover.setAttribute("popover", "");
    window.addEventListener("resize", ()=>{
        filterPopoverActive = filterPopoverTrigger.offsetParent !== null;
        if (filterPopoverActive) filterPopover.setAttribute("popover", "");
        else filterPopover.removeAttribute("popover");
    });
};


const $31b6f657dffad9ea$export$91db7bf3cf52d2ee = ()=>{
    const providerFilter = document.querySelector(".js-provider-filter");
    const providerList = document.querySelector(".js-provider-list");
    if (!providerFilter || !providerList) return;
    const providerItems = providerList.querySelectorAll(".js-provider-item");
    let delaySearch = null;
    if (!providerFilter || !providerList) return;
    providerFilter.focus();
    function filterProvider(filter) {
        clearTimeout(delaySearch);
        delaySearch = setTimeout(function() {
            processSearch(filter);
        }, 250);
    }
    function processSearch(filter) {
        var providerCount = 0;
        providerItems.forEach((provider)=>{
            var hideThis = provider.innerText.search(new RegExp(filter, "i")) < 0;
            provider.toggleAttribute("hidden", hideThis);
            providerCount += hideThis ? 0 : 1;
        });
        document.querySelector(".js-number-of-providers").innerText = providerCount;
    }
    providerFilter.addEventListener("input", function() {
        filterProvider(this.value);
    });
};


const $fc3e7aca76592be4$export$6bd9755bd64780dc = ()=>{
    const contextElement = document.getElementById("content-source");
    if (contextElement) $fc3e7aca76592be4$var$wrapTablesInCMSContent(contextElement);
};
const $fc3e7aca76592be4$var$wrapTablesInCMSContent = (contextElement)=>{
    Array.from(contextElement.querySelectorAll("table")).forEach((table)=>{
        table.outerHTML = `<div class="o-scroll-wrapper">${table.outerHTML}</div>`;
    });
};


const $d720ced4833f75d1$var$checkWidget = (e)=>{
    var checkAllFields = e.type == "submit";
    var currentField = e.target;
    if (checkAllFields) document.querySelectorAll(".js-form-error").forEach((errorLabel)=>{
        errorLabel.setAttribute("hidden", "hidden");
    });
    else document.querySelector(currentField.dataset.errorLabel).setAttribute("hidden", "hidden");
    if ((checkAllFields || currentField == hiddenLocationInput) && hiddenLocationInput.value == "") {
        e.preventDefault();
        document.querySelector(hiddenLocationInput.dataset.errorLabel).removeAttribute("hidden");
    }
    if ((checkAllFields || currentField == hiddenUsageInput) && hiddenUsageInput.value == "") {
        e.preventDefault();
        document.querySelector(hiddenUsageInput.dataset.errorLabel).removeAttribute("hidden");
    }
};
class $d720ced4833f75d1$export$76ee4dc31826cca7 {
    constructor(form){
        const hiddenLocationInput1 = document.getElementById("hiddenLocationInput");
        const hiddenUsageInput1 = document.getElementById("hiddenUsageInput");
        form.addEventListener("submit", $d720ced4833f75d1$var$checkWidget);
        hiddenLocationInput1.addEventListener("change", $d720ced4833f75d1$var$checkWidget);
        hiddenUsageInput1.addEventListener("change", $d720ced4833f75d1$var$checkWidget);
    }
}


const $474553cfcd9850af$export$6c6ef03b1e085646 = (widget)=>{
    const inputs = widget.querySelectorAll("input");
    Array.from(inputs).forEach((input)=>{
        input.addEventListener("change", ()=>{
            $474553cfcd9850af$var$checkHeatingSelection(widget);
        });
    });
};
const $474553cfcd9850af$var$setDisabled = (inputs)=>{
    inputs.forEach((input)=>{
        input.setAttribute("disabled", "");
    });
};
const $474553cfcd9850af$var$unsetDisabled = (inputs)=>{
    inputs.forEach((input)=>{
        input.removeAttribute("disabled");
    });
};
const $474553cfcd9850af$var$checkHeatingSelection = (widget)=>{
    const messageElement = widget.querySelector("#heatingWidgetError");
    const heatingTypes = widget.querySelectorAll("input[name='heatingType']");
    const heatingType = widget.querySelector("input[name='heatingType']:checked")?.value;
    const seperateMeters = widget.querySelectorAll("input[name='seperateMeter']");
    const seperateMeter = widget.querySelector("input[name='seperateMeter']:checked")?.value;
    const usageWidget = document.querySelector(".js-usage-widget");
    if (seperateMeter && seperateMeter == "no") {
        usageWidget.setAttribute("data-show-dual-usage", "");
        usageWidget.removeAttribute("data-show-single-dual-toggle");
    } else usageWidget.setAttribute("data-show-single-dual-toggle", "");
    heatingType == "heatpump" ? $474553cfcd9850af$var$setDisabled(seperateMeters) : $474553cfcd9850af$var$unsetDisabled(seperateMeters);
    seperateMeter == "no" ? $474553cfcd9850af$var$setDisabled(heatingTypes) : $474553cfcd9850af$var$unsetDisabled(heatingTypes);
    if (heatingType == "heatpump" || seperateMeter == "no") messageElement.removeAttribute("hidden");
    else messageElement.setAttribute("hidden", "");
};


/**
 * Basis tool voor het afhandelen van async communicatie. Hier is eventueel nog een standaard error afhandeling tussen te hangen.
 */ /**
 * Fetches data from the given URL using a GET request.
 * 
 * @async
 * @function getUrl
 * @param {string} url - The URL to fetch data from.
 * @returns {Promise<{status: number, data: any}>} The response status and data.
 */ const $80b8792c09f43040$var$getUrl = async (url)=>{
    const options = {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8"
        }
    };
    let response = await fetch(url, options);
    let status = response.status;
    let data = await response.json();
    return {
        status: status,
        data: data
    };
};
/**
 * Sends data to the given URL using a POST request.
 * 
 * @async
 * @function postUrl
 * @param {string} url - The URL to send data to.
 * @param {Object} postData - The data to send in the body of the POST request.
 * @returns {Promise<{status: number, data: any}>} The response status and data.
 */ const $80b8792c09f43040$var$postUrl = async (url, postData)=>{
    const options = {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify(postData)
    };
    let response = await fetch(url, options);
    let status = response.status;
    let data = null;
    try {
        data = await response?.json();
    } catch (error) {}
    return {
        status: status,
        data: data
    };
};
const $80b8792c09f43040$export$f8a0a232efd61230 = ()=>{
    return {
        getUrl: $80b8792c09f43040$var$getUrl,
        postUrl: $80b8792c09f43040$var$postUrl
    };
};


const $6be05c95c886a85c$var$asyncHelper = (0, $80b8792c09f43040$export$f8a0a232efd61230)();
const $6be05c95c886a85c$export$9f208cdfec86ac41 = ()=>{
    const ortusApi = window.ortus.api;
    /**
   * @method getForm
   * @async
   * @param {string} tariffId - The ID of the tariff.
   * @returns {Promise<Object>} The status and data of the form.
   */ const getForm = async (tariffId)=>{
        const url = `${ortusApi}signupform?tariffId=${tariffId}`;
        try {
            const { status: status, data: data } = await $6be05c95c886a85c$var$asyncHelper.getUrl(url);
            return {
                status: status,
                data: data
            };
        } catch (e) {
            console.log(e);
        }
    };
    /**
   * @method getTariffData
   * @async
   * @param {string} tariffId - The ID of the tariff.
   * @param {string} energyType - The type of energy.
   * @param {string} query - The query string.
   * @returns {Promise<Object>} The status and data of the tariff.
   */ const getTariffData = async (tariffId, energyType, query)=>{
        const detailUrl = `https://www.verivox.de/servicehook/offers/${energyType}/info/${query}/${tariffId}?partnerId=2624`;
        const proxyUrl = `${ortusApi}package/detail`;
        const { status: status, data: data } = await $6be05c95c886a85c$var$asyncHelper.postUrl(proxyUrl, {
            packageDetailsUri: detailUrl
        });
        return {
            status: status,
            data: data
        };
    };
    /**
   * @method getStreetsForPostCode
   * @async
   * @param {string} postCode - The postal code.
   * @param {string} city - The city name.
   * @returns {Promise<Array<string>>} A list of street names.
   */ const getStreetsForPostCode = async (postCode, city)=>{
        city = decodeURIComponent(city).split(" / ")[0].replace(/\//g, "-").trim();
        let url = `${ortusApi}signupform/streets?postCode=${postCode}&cityName=${city}`;
        const data = await fetch(url).then((response)=>response.json());
        const streets = data.map((s)=>s.Name);
        return streets;
    };
    /**
   * @method getCityDistricts
   * @async
   * @param {string} postCode - The postal code.
   * @param {string} [energyType='electricity'] - The type of energy.
   * @returns {Promise<Object>} The status and data of the city parts.
   */ // TODO: use alternative endpoint for getting cities without specifying a producttype
    const getCityDistricts = async (postCode, energyType = "electricity")=>{
        const url = `${ortusApi}location/${postCode}/${energyType}`;
        const { status: status, data: data } = await (0, $80b8792c09f43040$export$f8a0a232efd61230)().getUrl(url);
        return {
            status: status,
            data: data
        };
    };
    /**
   * @method getIsValidIBAN
   * @async
   * @param {string} iban - The IBAN to validate.
   * @returns {Promise<Object>} The status and data of the IBAN validation.
   */ const getIsValidIBAN = async (iban)=>{
        const url = `${ortusApi}signupform/iban?iBan=${iban}`;
        // Test for success: DE91500105174885792721
        // Test to fail: GT47195126765214373483528657
        return await $6be05c95c886a85c$var$asyncHelper.getUrl(url);
    };
    /**
   * @method getBenchmark
   * @async
   * @param {string} [product='Electricity'] - The product type.
   * @param {string} [profile='h0'] - The profile type.
   * @param {string} [postCode='20095'] - The postal code.
   * @param {string} [locationId='23232'] - The location ID.
   * @param {number} [totalUsage=2500] - The total usage.
   * @param {number} [heatingPower=0] - The heating power.
   * @returns {Promise<Object>} The status and data of the benchmark.
   */ const getBenchmark = async (product = "Electricity", profile = "h0", postCode = "20095", locationId = "23232", totalUsage = 2500, heatingPower = 0)=>{
        const url = `${ortusApi}benchmarks?product=${product}&profile=${profile}&postCode=${postCode}&locationId=${locationId}&totalUsage=${totalUsage}&heatingPower=${heatingPower}`;
        return await $6be05c95c886a85c$var$asyncHelper.getUrl(url);
    };
    /**
   * @method getBenchmarkSuppliers
   * @async
   * @param {string} [product='Electricity'] - The product type.
   * @param {string} [profile='h0'] - The profile type.
   * @param {string} [postCode='20095'] - The postal code.
   * @param {string} [locationId='23232'] - The location ID.
   * @param {number} [totalUsage=2500] - The total usage.
   * @param {number} [heatingPower=0] - The heating power.
   * @returns {Promise<Array<Object>>} A list of suppliers.
   */ const getBenchmarkSuppliers = async (product = "Electricity", profile = "h0", postCode = "20095", locationId = "23232", totalUsage = 2500, heatingPower = 0)=>{
        const { data: data, status: status } = await getBenchmark(product, profile, postCode, locationId, totalUsage, heatingPower);
        if (status !== 200) throw new Error("Could not fetch suppliers");
        const providers = data.providers.map((p)=>{
            return {
                name: p.content.text,
                label: p.content.text,
                id: p.id,
                tariffs: p.products
            };
        });
        return providers;
    };
    /**
   * @method getSuppliers
   * @async
   * @param {string} productType - electricity or gas 
   * @returns {Promise<Array<Object>>}  The status and data of the list of suppliers
   */ const getSuppliers = async (productType = "Electricity")=>{
        const url = `${ortusApi}providers/${productType}`;
        const apiResult = await $6be05c95c886a85c$var$asyncHelper.getUrl(url);
        const providers = apiResult.data.map((p)=>{
            return {
                name: p.name,
                label: p.name,
                id: p.id
            };
        });
        return providers;
    };
    /**
   * @method storeData
   * @async
   * @param {Object} postData - The data to post.
   * @param {string} productType - The type of product.
   * @param {string} tariffId - The ID of the tariff.
   * @returns {Promise<Object>} The status and data of the stored data.
   */ const storeData = async (postData, productType, tariffId)=>{
        postData.connectionData.currentProvider = postData.connectionData.currentProvider?.name ?? postData.connectionData.currentProvider;
        if (postData.connectionData.currentProvider === "Andere") postData.connectionData.currentProvider = postData.connectionData.otherProvider;
        const url = `${ortusApi}signuprequest/${productType}/${tariffId}`;
        const { status: status, data: data } = await $6be05c95c886a85c$var$asyncHelper.postUrl(url, postData);
        return {
            status: status,
            data: data
        };
    };
    /**
   * @method previewPdf
   * @async
   * @param {Object} postData - The data to post.
   * @param {string} productType - The type of product.
   * @param {string} tariffId - The ID of the tariff.
   * @returns {Promise<Object>} The status and data of the PDF preview.
   */ const previewPdf = async (postData, productType, tariffId)=>{
        const url = `${ortusApi}contractPreview/${tariffId}`;
        const { data: data, status: status } = await $6be05c95c886a85c$var$asyncHelper.postUrl(url, postData);
        return {
            status: status,
            data: data
        };
    };
    return {
        getCityDistricts: getCityDistricts,
        getBenchmarkSuppliers: getBenchmarkSuppliers,
        getSuppliers: getSuppliers,
        getStreetsForPostCode: getStreetsForPostCode,
        getBenchmark: getBenchmark,
        getForm: getForm,
        getTariffData: getTariffData,
        getIsValidIBAN: getIsValidIBAN,
        storeData: storeData,
        previewPdf: previewPdf
    };
};


// Shared state for the postal code change flag
let $5844f3601c6aa971$var$isPostalCodeChanged = false;
const $5844f3601c6aa971$export$fd899442b799a682 = (value)=>{
    $5844f3601c6aa971$var$isPostalCodeChanged = value;
};
const $5844f3601c6aa971$export$60d251412f427c30 = ()=>{
    return $5844f3601c6aa971$var$isPostalCodeChanged;
};



const $87dd73750fb93037$var$asyncHelper = (0, $80b8792c09f43040$export$f8a0a232efd61230)();
const $87dd73750fb93037$export$72faef17ae298338 = async (config)=>{
    const { data: initialData } = await $87dd73750fb93037$var$asyncHelper.getUrl(config.getApiUrl());
    let { filters: filters, results: results } = $87dd73750fb93037$var$getRelevantSearchData(initialData);
    return {
        filters: filters,
        results: results
    };
};
const $87dd73750fb93037$export$cfcc0908d6dfb8a6 = async (config, userFormData = {})=>{
    const productType = window.ortus.productType ?? "electricity";
    const baseFormData = {
        productType: productType,
        resultsOnly: false,
        pageSize: 10,
        page: 1,
        benchmark: 1
    };
    const formData = {
        ...baseFormData,
        ...userFormData
    };
    const { data: searchData } = await $87dd73750fb93037$var$asyncHelper.postUrl(`${config.getApiUrl()}calculator/energy`, formData);
    return $87dd73750fb93037$var$getRelevantSearchData(searchData);
};
const $87dd73750fb93037$var$getRelevantSearchData = (apiData)=>{
    const filters = apiData?.filters;
    const results = apiData?.offers;
    const benchmarkTariff = apiData?.benchmarkTariff;
    return {
        filters: filters,
        results: results,
        benchmarkTariff: benchmarkTariff
    };
};
const $87dd73750fb93037$export$cfce4cb39c87df1c = async (packageUrl)=>{
    const packageDetails = await $87dd73750fb93037$var$asyncHelper.getUrl(packageUrl);
    return packageDetails;
};


const $e9824b957d40652f$export$adf416f00cca6418 = (module, apiUrl = null)=>{
    const getApiUrl = ()=>{
        if (!apiUrl) throw new Error("No API URL provided");
        return apiUrl;
    };
    const getLsKey = ()=>{
        return `${module}-filters`;
    };
    return {
        getLsKey: getLsKey,
        getApiUrl: getApiUrl
    };
};



let $3fd9eea943d721cb$var$filterData = null;
let $3fd9eea943d721cb$var$searchResults = null;
let $3fd9eea943d721cb$var$config;
let $3fd9eea943d721cb$var$filterForm;
let $3fd9eea943d721cb$var$updateFunction;
let $3fd9eea943d721cb$var$storedPagingButton = "";
let $3fd9eea943d721cb$var$settings = {
    filterForm: null
};
const $3fd9eea943d721cb$export$be042cd8f6323421 = async ({ apiUrl: apiUrl, filterForm: filterForm, pagingButton: pagingButton })=>{
    $3fd9eea943d721cb$var$config = (0, $e9824b957d40652f$export$adf416f00cca6418)("wj", apiUrl);
    $3fd9eea943d721cb$var$settings.filterForm = filterForm;
    $3fd9eea943d721cb$var$storedPagingButton = pagingButton;
    let formData = $3fd9eea943d721cb$var$getFilterFormData();
    let { filters: filters, results: results, benchmarkTariff: benchmarkTariff } = await (0, $87dd73750fb93037$export$cfcc0908d6dfb8a6)($3fd9eea943d721cb$var$config, formData);
    const pageInput = filterForm.querySelector('input[name="page"]');
    setTimeout(()=>{
        pageInput.value = 1;
        $3fd9eea943d721cb$var$setFormInputWatcher(pageInput);
    }, 200);
    pagingButton.removeAttribute("hidden");
    if (!pagingButton.dataset.vxPagingBound) {
        pagingButton.addEventListener("click", $3fd9eea943d721cb$var$handlePagingButtonClick);
        pagingButton.dataset.vxPagingBound = "true";
    }
    return {
        comparisonData: {
            filters: filters,
            results: results,
            benchmarkTariff: benchmarkTariff,
            formData: formData
        },
        tooling: {
            onResultsUpdated: $3fd9eea943d721cb$var$onResultsUpdated
        }
    };
};
const $3fd9eea943d721cb$var$handlePagingButtonClick = async ()=>{
    const pageInput = $3fd9eea943d721cb$var$settings.filterForm.querySelector('input[name="page"]');
    const currentPage = parseInt(pageInput.value) || 1;
    pageInput.value = currentPage + 1;
    $3fd9eea943d721cb$var$onFiltersChanged({
        skipTimeout: true
    });
};
const $3fd9eea943d721cb$var$setFormInputWatcher = (pageInput)=>{
    const inputs = $3fd9eea943d721cb$var$settings.filterForm.querySelectorAll("input, select");
    Array.from(inputs).filter((i)=>{
        return i.dataset.skipSubmit !== "true";
    }).filter((i)=>{
        return i.dataset.ignore !== "true";
    }).forEach((input)=>{
        input.addEventListener("change", ()=>{
            pageInput.value = 1;
            $3fd9eea943d721cb$var$onFiltersChanged({
                skipTimeout: false
            });
        });
    });
    const priceDisplayInput = $3fd9eea943d721cb$var$settings.filterForm.querySelector("[name=priceDisplay]");
    $3fd9eea943d721cb$var$setPriceDisplayChangeHandler(priceDisplayInput);
};
const $3fd9eea943d721cb$var$setPriceDisplayChangeHandler = (priceDisplayInput)=>{
    priceDisplayInput.addEventListener("change", ()=>{
        const selectedPriceDisplay = priceDisplayInput.value;
        const wjPackageElements = document.querySelectorAll("wj-package");
        Array.from(wjPackageElements).forEach((element)=>{
            element.dataset.priceDisplay = selectedPriceDisplay;
        });
    });
};
const $3fd9eea943d721cb$var$getFilterFormData = ()=>{
    const inputsArr = Array.from($3fd9eea943d721cb$var$settings.filterForm.querySelectorAll("input, select"));
    const formProps = $3fd9eea943d721cb$var$getUniqueFormProps(inputsArr);
    const filterFormData = {};
    inputsArr.filter((i)=>!i.dataset.formProp).forEach((input)=>{
        let { value: value, checked: checked, name: name, type: type } = input;
        if (type == "radio") {
            if (checked) {
                if (value === "true") value = true;
                else if (value === "false") value = false;
                filterFormData[name] = value;
            }
        } else if (type == "checkbox") filterFormData[name] = checked;
        else filterFormData[name] = value;
    });
    // Reset benchmark to -1 ONLY if postal code has changed
    if ((0, $5844f3601c6aa971$export$60d251412f427c30)()) {
        filterFormData.benchmark = "-1"; // Reset benchmark
        filterFormData[""] = false;
    }
    formProps.forEach((formProp)=>{
        let myValue = [];
        myValue = inputsArr.filter((i)=>i.dataset.formProp === formProp && i.checked).map((input)=>{
            let { value: value } = input;
            return value;
        });
        filterFormData[formProp] = myValue.join(",");
    });
    return filterFormData;
};
const $3fd9eea943d721cb$var$getUniqueFormProps = (inputsArr)=>{
    // TODO  check if needed
    const formProps = [];
    inputsArr.map((i)=>{
        const formProp = i.dataset.formProp;
        if (formProp && formProps.indexOf(formProp) === -1) formProps.push(formProp);
    });
    return formProps;
};
let $3fd9eea943d721cb$var$searchTimeout = 1;
const $3fd9eea943d721cb$var$resultsWrapper = document.getElementById("packageResults");
const $3fd9eea943d721cb$var$savingsWrapper = document.querySelector(".js-saving-banner");
const $3fd9eea943d721cb$var$onFiltersChanged = async ({ skipTimeout: skipTimeout = false })=>{
    if ($3fd9eea943d721cb$var$searchTimeout) {
        clearTimeout($3fd9eea943d721cb$var$searchTimeout);
        $3fd9eea943d721cb$var$searchTimeout = null;
    }
    $3fd9eea943d721cb$var$resultsWrapper.style.filter = "blur(5px)";
    $3fd9eea943d721cb$var$savingsWrapper.style.filter = "blur(5px)";
    const timeoutDuration = skipTimeout ? 0 : 800;
    $3fd9eea943d721cb$var$searchTimeout = setTimeout(async ()=>{
        $3fd9eea943d721cb$var$storedPagingButton.setAttribute("disabled", "disabled");
        let formValidation = $3fd9eea943d721cb$var$formIsValid($3fd9eea943d721cb$var$settings.filterForm);
        if (formValidation.isValid) await $3fd9eea943d721cb$var$executeSearch();
        else console.log(formValidation.errors);
        $3fd9eea943d721cb$var$storedPagingButton.removeAttribute("disabled");
        $3fd9eea943d721cb$var$resultsWrapper.style.filter = "";
        $3fd9eea943d721cb$var$savingsWrapper.style.filter = "";
    }, timeoutDuration);
};
const $3fd9eea943d721cb$var$formIsValid = (form)=>{
    let isValid = true;
    let errors = [];
    const hiddenLocationInput = form.querySelector("#hiddenLocationInput").value;
    if (hiddenLocationInput == "") {
        errors.push("Kein addresse gefunden. Bitte versuchen Sie es erneut.");
        isValid = false;
    }
    return {
        isValid: isValid,
        errors: errors
    };
};
const $3fd9eea943d721cb$var$executeSearch = async (appendingData)=>{
    // only execute the search if the postal code has not changed
    if (!(0, $5844f3601c6aa971$export$60d251412f427c30)()) {
        let searchData = $3fd9eea943d721cb$var$getFilterFormData();
        searchData.resultsOnly = true;
        let formData = {
            ...searchData,
            ...appendingData
        };
        let { filters: filters, results: results, benchmarkTariff: benchmarkTariff } = await (0, $87dd73750fb93037$export$cfcc0908d6dfb8a6)($3fd9eea943d721cb$var$config, searchData);
        $3fd9eea943d721cb$var$updateFunction({
            filters: filters,
            results: results,
            benchmarkTariff: benchmarkTariff,
            formData: formData
        });
        (0, $5844f3601c6aa971$export$fd899442b799a682)(false); // Reset the flag
    }
};
const $3fd9eea943d721cb$var$onResultsUpdated = (updateData)=>{
    $3fd9eea943d721cb$var$updateFunction = updateData;
};


const $6a437dcba1085657$var$renderPackages = (searchResultsData)=>{
    const priceDisplay = searchResultsData.formData.priceDisplay;
    searchResultsData.data.forEach((element)=>{
        let myElement = document.createElement("wj-package");
        myElement.dataset.packageElement = JSON.stringify(element);
        myElement.dataset.priceDisplay = priceDisplay;
        searchResultsData.target.appendChild(myElement);
    });
};
var $6a437dcba1085657$export$2e2bcd8739ae039 = $6a437dcba1085657$var$renderPackages;



const $9ad4a19502edd57e$export$394e73e0cf9f022a = async ()=>{
    const ortusApi = window.ortus.api;
    const wrapper = document.querySelector(".js-comparison-wrapper");
    const filterForm1 = document.getElementById("filterForm");
    const pagingButton = document.getElementById("pagingButton");
    if (!filterForm1) {
        console.info("No form supplied. Cancelling initialisation");
        return;
    }
    const { postCode: postCode, city: city, location: location1 } = $9ad4a19502edd57e$var$getUrlParameters();
    if (filterForm1.querySelector("#hiddenLocationInput").value === "") filterForm1.querySelector("#hiddenLocationInput").value = location1;
    const searchTool = await (0, $3fd9eea943d721cb$export$be042cd8f6323421)({
        apiUrl: ortusApi,
        filterForm: filterForm1,
        pagingButton: pagingButton
    });
    searchTool.tooling.onResultsUpdated($9ad4a19502edd57e$var$handleNewData);
    $9ad4a19502edd57e$var$setSupplierAndTariffSelects(searchTool.comparisonData.benchmarkTariff);
    setTimeout(()=>{
        $9ad4a19502edd57e$var$handleNewData(searchTool.comparisonData);
        wrapper.querySelector("bc-loading-icon")?.remove();
    }, 1);
};
const $9ad4a19502edd57e$var$setSupplierAndTariffSelects = async (benchmarkTariff)=>{
    let productType = filterForm.querySelector("#hiddenProductType").value;
    let locationId = filterForm.querySelector("#hiddenLocationInput").value;
    let postCode = filterForm.querySelector("#postalCode").value;
    let usage = filterForm.querySelector("#hiddenUsageInput").value;
    const suppliers = await (0, $6be05c95c886a85c$export$9f208cdfec86ac41)().getBenchmarkSuppliers(productType, undefined, postCode, locationId, usage);
    let benchmarkSupplierId = null;
    let benchmarkTariffId = null;
    if (benchmarkTariff) {
        benchmarkSupplierId = benchmarkTariff.provider?.id;
        benchmarkTariffId = benchmarkTariff.id;
    }
    let supplierSelect = document.getElementById("previousSupplier");
    let tariffSelect = document.getElementById("previousTariff");
    supplierSelect.innerHTML = "";
    supplierSelect.innerHTML += `<option value="">Bitte wahle dein Anbieter aus</option>`;
    suppliers.forEach((supplier)=>{
        let isSelected = supplier.id == benchmarkSupplierId ? "selected" : "";
        supplierSelect.innerHTML += `<option ${isSelected} value="${supplier.id}" data-tariffs='${JSON.stringify(supplier.tariffs)}' value="${supplier.name}">${supplier.name}</option>`;
    });
    supplierSelect.addEventListener("change", (e)=>{
        let selectedSupplierId = e.target.value;
        if (selectedSupplierId) {
            let selectedSupplier = suppliers.find((s)=>s.id === selectedSupplierId);
            tariffSelect.innerHTML = "";
            tariffSelect.innerHTML += `<option value="-1">Bitte wahle dein Tarif aus</option>`;
            selectedSupplier.tariffs.forEach((tariff)=>{
                let isSelected = tariff.id == benchmarkTariffId ? "selected" : "";
                tariffSelect.innerHTML += `<option ${isSelected} value="${tariff.id}">${tariff.content.text}</option>`;
            });
        }
    });
    if (benchmarkSupplierId) supplierSelect.dispatchEvent(new Event("change", {
        bubbles: true
    }));
};
const $9ad4a19502edd57e$var$getUrlParameters = ()=>{
    const params = Object.fromEntries(new URLSearchParams(location.search));
    return params;
};
const $9ad4a19502edd57e$var$euroDisplay = (amount)=>{
    if (isNaN(amount) && typeof amount === "string" && amount.indexOf(",") > -1) amount = amount.replace(/\,/g, ".");
    return parseFloat(amount).toFixed(2).replace(".", ",") + "&nbsp;&euro;";
};
const $9ad4a19502edd57e$var$handleNewData = (searchData)=>{
    let results, benchmarkTariff, formData;
    if (searchData) ({ results: results, benchmarkTariff: benchmarkTariff, formData: formData } = searchData);
    if (!results) return;
    const resultsContainer = document.getElementById("packageResults");
    if (benchmarkTariff) {
        const savingAmount = results[0]?.cost.savings.amount;
        const savingAmountRounded = Math.round(savingAmount);
        if (savingAmount > 20) {
            document.querySelector(".js-saving-banner__saving-amount").innerHTML = savingAmountRounded.toString() + "&nbsp;&euro;";
            document.querySelector(".js-saving-banner__benchmark-amount").innerHTML = $9ad4a19502edd57e$var$euroDisplay(benchmarkTariff.totalCostInEuro);
            document.querySelector(".js-saving-banner__benchmark-provider").innerHTML = benchmarkTariff.providerName.content.text;
            document.querySelector(".js-saving-banner__benchmark-location").innerHTML = benchmarkTariff.tariff?.content.text;
            document.querySelector(".js-saving-banner__saving-header").removeAttribute("hidden");
            document.querySelector(".js-saving-banner__saving-subtext").removeAttribute("hidden");
            document.querySelector(".js-saving-banner__low-saving-message").setAttribute("hidden", true);
        } else {
            document.querySelector(".js-saving-banner__saving-header").setAttribute("hidden", true);
            document.querySelector(".js-saving-banner__saving-subtext").setAttribute("hidden", true);
            document.querySelector(".js-saving-banner__low-saving-message").removeAttribute("hidden");
        }
        document.querySelector(".js-saving-banner").removeAttribute("hidden");
        if (!benchmarkTariff.providerName.content.text) {
            document.querySelector(".js-meta-data--default-supplier").setAttribute("hidden", true);
            document.querySelector(".js-meta-data--heatingelectricity-default-provider").setAttribute("hidden", true);
        } else document.querySelector(".js-meta-data--default-supplier").removeAttribute("hidden");
        document.querySelector(".js-meta-data--supplier").innerHTML = benchmarkTariff.providerName.content.text;
        document.querySelector(".js-meta-data--tariff").innerHTML = benchmarkTariff.tariffName.content.text;
    }
    if (window.ortus.preselectedValues?.city) document.querySelector(".js-meta-data--city").innerHTML = window.ortus.preselectedValues.city;
    if (window.ortus.preselectedValues?.energyArea) {
        let energyArea = window.ortus.preselectedValues.energyArea;
        if (energyArea === "heating") ;
        else if (energyArea === "green") document.querySelector('input[name="isGreenElectricity"][value="true"]').checked = true;
    }
    const page = parseInt(formData.page);
    const pageSize = parseInt(formData.pageSize);
    if (page == 1) resultsContainer.innerHTML = "";
    let searchResultsData = {
        data: results,
        target: resultsContainer,
        formData: formData
    };
    Array.from(document.querySelectorAll("bc-loading-icon"))?.forEach((icon)=>icon.remove());
    (0, $6a437dcba1085657$export$2e2bcd8739ae039)(searchResultsData);
};


let $2c95b4ed0ac49682$var$isPostalCodeChanged = false; // Flag to track postal code changes
/*
  * addressSolver
  Vanilla JS implementatie van de address solver met een reguliere template in de CSHTML file in het webproject.
*/ class $2c95b4ed0ac49682$export$33f74ecdf75d2956 {
    constructor(wrapper){
        this.postCodeInput = document.getElementById("postalCode");
        this.selectedAddress = document.getElementById("selectedAddress");
        //When using Enter key, move the focus to the address input so it does not trigger the submit
        this.postCodeInput.onkeydown = (e)=>{
            if (e.key === "Enter") this.selectedAddressRef.focus();
        };
        const handleChange = ()=>{
            (0, $5844f3601c6aa971$export$fd899442b799a682)(true);
            this._fetchAddress();
        };
        this.postCodeInput.addEventListener("change", handleChange);
        this.selectAddressWrapper = document.getElementById("selectAddressWrapper");
        this.errorText = document.getElementById("errorText");
        this.selectedAddress = null;
        this.isLoading = false;
        this.loadingIcon = document.getElementById("address-solver-loader");
        this.foundAddresses = [];
        this.selectedAddressRef = document.querySelector("#selectedAddress");
        this.selectedAddressRef.addEventListener("change", ()=>{
            this._selectAddress();
        });
        this.inputRef = document.querySelector("#inputRef");
        this.productType = document.getElementById("hiddenProductType");
        this.postCode = wrapper.dataset.preselectedPostcode;
        this.location = wrapper.dataset.preselectedLocation;
        this.city = wrapper.dataset.preselectedCity;
        if (this.postCode) {
            this.postCodeInput.value = this.postCode;
            this._setPreselectedCity();
            return;
        }
        if (this.preselectedCity) {
            this.selectedAddress = decodeURIComponent(this.city);
            this._setPreselectedCity();
            return;
        }
        if (window.ortus.preselectedValues && window.ortus.preselectedValues.city) {
            this.city = window.ortus.preselectedValues.city;
            this._setPreselectedCity();
            return;
        }
        this._fetchAddress();
    }
    async _setPreselectedCity() {
        await this._fetchAddress();
        let options = this.selectedAddressRef.options;
        Array.from(options).forEach((option)=>{
            if (option.value == this.city) option.setAttribute("selected", "selected");
        });
    }
    _setLoadingState() {
        this.loadingIcon.hidden = !this.isLoading;
        if (this.isLoading) this.selectAddressWrapper.setAttribute("hidden", "hidden");
        else this.selectAddressWrapper.removeAttribute("hidden");
    }
    _selectAddress() {
        let select = this.selectedAddressRef;
        let selectedOption = select.options[select.selectedIndex];
        let selectedAddress = selectedOption.dataset.address;
        document.getElementById("hiddenLocationInput").value = "";
        if (selectedAddress) {
            let address = JSON.parse(selectedAddress);
            this.selectedAddress = address.fullName;
            document.getElementById("hiddenLocationInput").value = address.id ?? -1;
            document.getElementById("hiddenLocationInput").dispatchEvent(new Event("change", {
                bubbles: true
            }));
            this.errorText.innerHTML = "";
            this.errorText.hidden = true;
            // reset Anbieter and Tarif, otherwise the benchmark tariff might result in issues due to not being available at the chosen location.
            let previousSupplierElement = document.getElementById("previousSupplier");
            if (previousSupplierElement) previousSupplierElement.value = "";
            let previousTariffElement = document.getElementById("previousTariff");
            if (previousTariffElement) previousTariffElement.value = "-1";
            (0, $9ad4a19502edd57e$export$394e73e0cf9f022a)();
        }
    }
    _clearAddress() {
        this.selectedAddress = null;
        document.getElementById("hiddenLocationInput").value = "";
    }
    async _fetchAddress() {
        const userPostalCode = this.postCodeInput.value;
        while(this.selectedAddressRef.children.length > 1)this.selectedAddressRef.removeChild(this.selectedAddressRef.lastChild);
        if (userPostalCode.length < 5 || userPostalCode.length > 6) {
            document.getElementById("hiddenLocationInput").value = "";
            this.selectedAddressRef.setAttribute("disabled", "disabled");
            return false;
        }
        this.selectedAddressRef.removeAttribute("disabled");
        this.foundAddresses = [];
        this.isLoading = true;
        this._setLoadingState();
        this.loadingIcon.hidden = false;
        this.errorText.innerHTML = "";
        this.errorText.hidden = true;
        let { data: data, status: status } = await (0, $6be05c95c886a85c$export$9f208cdfec86ac41)().getCityDistricts(userPostalCode, this.productType.value);
        if (status == 200) {
            if (data.locationList?.length > 0) this.foundAddresses = data.locationList;
            else if (data.mainName != null) this.foundAddresses.push({
                fullName: data.mainName,
                id: data.mainId
            });
            let selected = false;
            this.foundAddresses.forEach((address)=>{
                let option = document.createElement("option");
                option.value = address.fullName;
                option.dataset.address = JSON.stringify(address);
                option.innerText = address.fullName;
                if (address.id && address.id === window.ortus.preselectedValues?.location) {
                    option.setAttribute("selected", "selected");
                    selected = true;
                } else option.removeAttribute("selected");
                this.selectedAddressRef.appendChild(option);
            });
            if (!selected) {
                this.selectedAddressRef.options[1].setAttribute("selected", "selected");
                this._selectAddress();
            }
        } else {
            this.errorText.innerHTML = "Es ist ein Fehler aufgetreten. Kontrolieren Sie Ihre Postleitzahl";
            this.errorText.hidden = false;
            var filerSectionYourData = document.getElementById("filter-section__your-data");
            filerSectionYourData != null && (filerSectionYourData.checked = true);
        }
        this.isLoading = false;
        this._setLoadingState();
    }
}


window.addEventListener("DOMContentLoaded", ()=>{
    let inputWidget, heatingWidget, addressSolver;
    (0, $68cce00e20779c30$export$240cd81d1fa164a8)();
    (0, $31b6f657dffad9ea$export$91db7bf3cf52d2ee)();
    (0, $fc3e7aca76592be4$export$6bd9755bd64780dc)();
    (0, $7e4debd3f64ec3ac$export$f808344a2ba3e03)();
    if (inputWidget = document.querySelector(".js-input-widget")) new (0, $d720ced4833f75d1$export$76ee4dc31826cca7)(inputWidget);
    if (heatingWidget = document.querySelector(".js-heating-electricity-widget")) (0, $474553cfcd9850af$export$6c6ef03b1e085646)(heatingWidget);
    if (addressSolver = document.getElementById("address-solver")) new (0, $2c95b4ed0ac49682$export$33f74ecdf75d2956)(addressSolver);
});

})();
//# sourceMappingURL=base.js.map
